export { resolvePositioningShorthand } from './resolvePositioningShorthand';
export { usePositioning } from './usePositioning';
export { getPlacementString } from './utils';
export { POSITIONS, ALIGNMENTS } from './constants';
export type { PositioningProps, PositioningShorthand, PositioningReturn } from './types';

export type {
  Alignment,
  Position,
  PositioningImperativeRef,
  PositioningShorthandValue,
} from '@fluentui/react-positioning';
